'use client';

import clsx from 'clsx';
import { FC, useContext } from 'react';
import styles from './BrandsAlphabet.module.css';
import { BrandsAlphabetProps } from './types';
import BrandsPageContext, { BrandsPageContextType } from '@/context/BrandsPageContext';

const BrandsAlphabet: FC<BrandsAlphabetProps> = ({ alphabet }) => {
  const { onSelectBrandLetter } = useContext(BrandsPageContext) as BrandsPageContextType;
  return (
    <div onClick={onSelectBrandLetter} className={styles.alphabetContainer}>
      {alphabet.map((leter) => (
        <span
          key={leter}
          className={clsx(styles.leter, { [styles.letterSymbols]: leter === 'J' || leter === 'Q' })}
          data-letter={`letter-${leter}`}
        >
          {leter}
        </span>
      ))}
    </div>
  );
};

export default BrandsAlphabet;
